import { LegacyPagePaths } from "App/routes/paths";
import { TranscriptsRerouter } from "Pages/transcripts/TranscriptsRouter";

import type { RegalRouteObject } from "App/routes/types";

export const rerouteTranscriptsRoute: RegalRouteObject = {
    path: LegacyPagePaths.transcripts,
    element: <TranscriptsRerouter />,
    children: [
        {
            path: "*",
            element: <TranscriptsRerouter />,
        },
    ],
};
